<template>
  <div class="title">
    <h5>{{ title }}</h5>
  </div>
</template>
<script>
export default {
  computed: {
    title() {
      if (this.$store.state.Auth.headerName === "") {
        return this.$route.name;
      } else {
        return this.$store.state.Auth.headerName;
      }
    },
  },
};
</script>
<style scoped>
.title h5 {
  padding: 2px 10px !important;
  border-left: 4px solid rgb(25, 115, 226);
  text-transform: uppercase;
  font-size: 18px;
}

@media screen and (max-width: 1024px) {
  .title h5 {
    font-size: 15px;
    padding: 0px 10px !important;
    border-left: 3px solid rgb(25, 115, 226);
  }
}
</style>
